export const HINT_DISMISSED_LS = 'hint-dismissed';
export const MESSAGES_LS = 'messages';
